import { render, staticRenderFns } from "./LoginRelationExtends.vue?vue&type=template&id=45441f64"
import script from "./LoginRelationExtends.vue?vue&type=script&lang=js"
export * from "./LoginRelationExtends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports